module.exports = __webpack_public_path__ + "static/media/star.4bf118e7.svg";